import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { AxiosResponse, AxiosError } from 'axios';
import { ApiComm } from '../comm/http/ApiComm';
import { ERROR_CODES } from '../common/errorMessage';
import { clearAccessToken } from '../common/Configuration';

type MenuItem = {
  label: string;
  path: string | null;
  sub: MenuItem[] | null;
};

const menuData: MenuItem[] = [
  { label: '1. 대시보드', path: '/main/dashboard', sub: null },
  { label: '2. 독서,필사 통계', path: '/main/reading-scripting-statistics', sub: null },
  { label: '3. 모임 통계', path: '/main/meeting-statistics', sub: null },
  { label: '4. 컨텐츠 검토 및 신고 관리', path: '/main/content-review-and-report-management', sub: null },
  { label: '5. 회원 관리', path: '/main/member-management', sub: null },
  { label: '6. 모임 관리', path: '/main/meeting-management', sub: null },
  { label: '8. 운영 설정', path: '/main/operation-settings', sub: null },
  { label: '9. 배너관리', path: '/main/banner-management', sub: null },
  {
    label: '10. 메뉴10',
    path: null,
    sub: [{ label: '10-1. 메뉴10-1', path: '/main/subpage10-1', sub: null }],
  },
];

const MainPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openMenus, setOpenMenus] = useState<Record<string, boolean>>({});


  useEffect(() => {


    const handleTokenError = (errorCode: number) => {
      switch(errorCode){
        case ERROR_CODES.UNAUTHORIZATIONERROR:
        case ERROR_CODES.INVALIDTOKEN:
        case ERROR_CODES.EXPIREDTOKEN:
        case ERROR_CODES.INVALIDATEDTOKEN:
          window.location.href = '/';
          return true;
      }
      return false;
    };

    const interceptorId = ApiComm.hookResponse((response: AxiosResponse) => {
      console.log("response hook :",response.data, ERROR_CODES.UNAUTHORIZATIONERROR);
      if(handleTokenError(response?.data?.errorCode)){
        clearAccessToken();
        return response;
      }
      return response;
    }, (error: AxiosError) => {
      //console.log("error hook error :",error, ERROR_CODES.UNAUTHORIZATIONERROR);
      //handleTokenError(error?.response?.data?.errorCode);
      return error;
    });
    return ()=>{ApiComm.unhookResponse(interceptorId);};
  }, []);
  



  const handleMenuClick = (item: MenuItem) => {
    if (item.sub && item.sub.length > 0) {
      // 토글
      setOpenMenus(prev => ({ ...prev, [item.label]: !prev[item.label] }));
    } else if (item.path) {
      navigate(item.path);
    }
  };

  const isActivePath = (path: string | null) => {
    if (!path) return false;
    return location.pathname.startsWith(path);
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f3f5fb' }}>
      {/* 왼쪽 메뉴 영역 */}
      <div
        style={{
          width: 260,
          background: '#0b2447',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* 로고 영역 */}
        <div
          style={{
            height: 64,
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
            borderBottom: '1px solid rgba(255,255,255,0.08)',
            fontWeight: 700,
            fontSize: 20,
          }}
        >
          <Icon name="book" style={{ marginRight: 8 }} />
          Nubuk Admin
        </div>

        {/* 메뉴 리스트 */}
        <div style={{ padding: '12px 8px' }}>
          {menuData.map(item => {
            const hasSub = !!item.sub && item.sub.length > 0;
            const opened = !!openMenus[item.label];
            const active = isActivePath(item.path);

            return (
              <div key={item.label}>
                <div
                  onClick={() => handleMenuClick(item)}
                  style={{
                    cursor: 'pointer',
                    padding: '10px 14px',
                    borderRadius: 6,
                    marginBottom: 4,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    background: active
                      ? 'rgba(255,255,255,0.12)'
                      : 'transparent',
                    color: '#fff',
                  }}
                >
                  <span>{item.label}</span>
                  {hasSub && (
                    <Icon
                      name={opened ? 'angle up' : 'angle down'}
                      style={{ marginLeft: 8 }}
                    />
                  )}
                </div>
                {hasSub && opened && (
                  <div style={{ paddingLeft: 16, marginBottom: 4 }}>
                    {item.sub!.map(sub => {
                      const subActive = isActivePath(sub.path);
                      return (
                        <div
                          key={sub.label}
                          onClick={() => handleMenuClick(sub)}
                          style={{
                            cursor: 'pointer',
                            padding: '8px 12px',
                            borderRadius: 6,
                            marginBottom: 2,
                            background: subActive
                              ? 'rgba(255,255,255,0.16)'
                              : 'transparent',
                            color: '#dfe7ff',
                            fontSize: 13,
                          }}
                        >
                          {sub.label}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* 오른쪽 컨텐츠 영역 */}
      <div style={{ flex: 1, padding: '24px 32px' }}>
        <Outlet />
      </div>
    </div>
  );
};

export default MainPage;

